export enum SearchType {
  QUOTE = "quote",
  POLICY = "policy"
}
